/**
 * TanStack Query hooks for `kyc-aml-vetting-workflow-fintech-vertical`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	kycAmlVettingWorkflowFintechVerticalQueryKeys,
	type CreateKycAmlVettingWorkflowFintechVerticalBody,
	type ListKycAmlVettingWorkflowFintechVerticalResponse,
	type KycAmlVettingWorkflowFintechVerticalRow,
} from "./api";

export function useKycAmlVettingWorkflowFintechVerticalList(): UseQueryResult<ListKycAmlVettingWorkflowFintechVerticalResponse, Error> {
	return useQuery({
		queryKey: kycAmlVettingWorkflowFintechVerticalQueryKeys.list(),
		queryFn: list,
	});
}

export function useKycAmlVettingWorkflowFintechVerticalCreate(): UseMutationResult<KycAmlVettingWorkflowFintechVerticalRow, Error, CreateKycAmlVettingWorkflowFintechVerticalBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kycAmlVettingWorkflowFintechVerticalQueryKeys.all });
		},
	});
}

export function useKycAmlVettingWorkflowFintechVerticalDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kycAmlVettingWorkflowFintechVerticalQueryKeys.all });
		},
	});
}
